import { useEffect } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { RoutinesView, useRoutineUi } from "@/modules/routines";

export const Route = createFileRoute("/_app/routines")({
  component: RoutinesRoute,
});

function RoutinesRoute() {
  // Reset to the list whenever the route mounts. Detail/edit/create
  // sub-views live in `useRoutineUi`; without this, navigating away
  // mid-detail and back would re-open the previous detail by sticky
  // store state.
  useEffect(() => {
    useRoutineUi.getState().openList();
  }, []);
  // Sidebar entry — always personal. Team-space routines live under the
  // space dashboard's «Автоматизации» tab.
  return <RoutinesView scope={{ kind: "personal" }} />;
}
